export default "__VITE_ASSET__492a4647__"